<template>
  <section id="cases" class="cases">
    <div class="container">
      <header class="section-head">
        <h2 class="section-title">案例展示</h2>
        <p class="section-lead">
          持续拥抱物联网与人工智能浪潮，结合数字资源与生态服务，助力文化行业创新发展
        </p>
      </header>
      <div class="cases-grid">
        <article
          v-for="(caseItem, idx) in cases"
          :key="caseItem.id != null ? caseItem.id : idx"
          class="case-card"
        >
          <router-link
            :to="{ name: 'case-detail', params: { id: String(caseItem.id) } }"
            class="case-link"
          >
            <div class="case-image" :class="{ 'case-image--ready': imageReady[caseItem.id] }">
              <img
                v-if="caseItem.image"
                :src="caseItem.image"
                :alt="caseItem.title"
                class="case-cover"
                :loading="idx < 8 ? 'eager' : 'lazy'"
                decoding="async"
                :fetchpriority="idx === 0 ? 'high' : idx < 8 ? 'auto' : 'low'"
                @load="onTileImageLoad(caseItem.id)"
                @error="onTileImageLoad(caseItem.id)"
              >
              <span v-else class="case-placeholder" aria-hidden="true">📘</span>
            </div>
            <div class="case-content">
              <h3 class="case-title">{{ caseItem.title }}</h3>
              <p class="case-meta">{{ caseItem.subtitle || caseItem.category || '' }}</p>
              <p class="case-description">{{ caseItem.intro || caseItem.summary || caseItem.subtitle || '' }}</p>
            </div>
          </router-link>
        </article>
      </div>
      <p class="section-cta">
        <router-link to="/cases" class="link-more">进入案例中心 →</router-link>
      </p>
    </div>
  </section>
</template>

<script>
import { fetchCases } from '../api/cases'

export default {
  name: 'CasesSection',
  props: {
    prefetchItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      cases: [],
      imageReady: {}
    }
  },
  async mounted() {
    this.imageReady = {}
    if (Array.isArray(this.prefetchItems) && this.prefetchItems.length) {
      this.cases = this.prefetchItems.map((item) => ({ ...item }))
      return
    }
    const list = await fetchCases()
    this.cases = Array.isArray(list) ? list : []
  },
  methods: {
    onTileImageLoad(id) {
      if (id == null) return
      this.imageReady = { ...this.imageReady, [id]: true }
    }
  }
}
</script>

<style scoped>
.cases {
  padding: 100px 0;
  background: #f8fafc;
}

.section-head {
  text-align: center;
  margin-bottom: 48px;
}

.section-title {
  font-size: 42px;
  margin-bottom: 16px;
  color: #0c4a6e;
  font-weight: 700;
}

.section-lead {
  font-size: 17px;
  color: #64748b;
  max-width: 720px;
  margin: 0 auto;
  line-height: 1.75;
}

.cases-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  gap: 28px;
  max-width: 1200px;
  margin: 0 auto;
}

.case-card {
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  transition: transform 0.25s, box-shadow 0.25s;
}

.case-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 48px rgba(12, 74, 110, 0.12);
}

.case-image {
  height: 168px;
  background: linear-gradient(135deg, #0c4a6e 0%, #0369a1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: relative;
}

.case-image::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(110deg, transparent 0%, rgba(255, 255, 255, 0.22) 45%, transparent 90%);
  background-size: 220% 100%;
  animation: case-image-shimmer 1.35s ease-in-out infinite;
  pointer-events: none;
  z-index: 0;
}

.case-image--ready::after {
  display: none;
}

.case-cover {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  opacity: 0;
  transition: opacity 0.35s ease;
}

.case-image--ready .case-cover {
  opacity: 1;
}

@keyframes case-image-shimmer {
  0% { background-position: 100% 0; }
  100% { background-position: -100% 0; }
}

.case-placeholder {
  font-size: 56px;
  opacity: 0.9;
}

.case-content {
  padding: 24px 26px 28px;
}

.case-link {
  display: block;
  color: inherit;
}

.case-title {
  font-size: 20px;
  margin-bottom: 8px;
  color: #0c4a6e;
  font-weight: 600;
}

.case-meta {
  font-size: 13px;
  color: #0284c7;
  margin: 0 0 12px;
  font-weight: 500;
}

.case-description {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  margin: 0;
}

.section-cta {
  text-align: center;
  margin-top: 40px;
}

.link-more {
  color: #0284c7;
  font-weight: 600;
  font-size: 16px;
}

.link-more:hover {
  color: #0369a1;
}

@media (max-width: 768px) {
  .cases-grid {
    grid-template-columns: 1fr;
  }

  .section-title {
    font-size: 32px;
  }
}
</style>
